class AgeGate extends HTMLElement {
  constructor() {
    super();

    // 99 represents any location where user access is not permitted
    this.countryInvalild = 99;
    this.form = this.querySelector(".js-age-gate-form");
    this.inputs = this.querySelectorAll(".js-input");
    this.checkbox = this.querySelector(".js-checkbox");
    this.submit = this.querySelector(".js-submit");
    this.errorMessage = this.querySelector(".js-error");
    this.permittedAge = parseInt(this.dataset.age);

    if (this.permittedAge === this.countryInvalild) this.removeAccess()
    else this.addListeners();
  }

  removeAccess() {
    this.errorMessage.innerHTML = window.ageGateErrorMessages.country;
  }

  addListeners() {
    this.inputs.forEach((input, index) => {

      input.addEventListener("keyup", event => {
        this.validateInput(event, input, index)
      })

      input.addEventListener("change", event => {
        this.validateInput(event, input, index)
      })
          
    });

    this.form.addEventListener("submit", event => this.submitForm(event));

    if (this.hasExpired()) publish(PUB_SUB_EVENTS.modalOpen, { type: "age-gate" });
  }

  hasExpired() {
    const expiration = this.getExpiration();
    const now = new Date().getTime();

    return expiration && now > expiration || !expiration;
  }

  getExpiration() {
    return window.localStorage.getItem("age-gate") ?? null;
  }

  setExpiration(date) {
    window.localStorage.setItem("age-gate", `${date}`);
  }

  validateInput(event, input, index) {
    const isDay = input.name.includes("day");
    const isMonth = input.name.includes("month");
    const isYear = input.name.includes("year");

    if ((isDay || isMonth) && input.value.length < 2) return;
    if (isYear && input.value.length != 4) {
      input.value = input.value.substr(0, 4)
      return;
    }

    if (parseInt(input.value) < parseInt(input.min)) {
      input.value = input.min
      return;
    }
    if (parseInt(input.value) > parseInt(input.max)) {
      input.value = input.max
      return;
    }

    event.preventDefault();

    if (isYear) this.submit.focus();
    else this.inputs[index + 1].focus();
  }

  submitForm(event) {
    event.preventDefault();

    const day = this.form.querySelector("#AgeGate-Day").value;
    const month = parseInt(this.form.querySelector("#AgeGate-Month").value) - 1;
    const year = this.form.querySelector("#AgeGate-Year").value;
    const ageInput = new Date(year, month, day).toDateString();
    const validAge = this.getAge(ageInput) < this.permittedAge;

    if (!this.form.checkValidity()) return this.displayErrorMessage("dob");
    if (validAge) return this.displayErrorMessage("age");

    publish(PUB_SUB_EVENTS.modalClose, { type: "age-gate" });

    let date = new Date();

    date.setDate(date.getDate() + 30);

    if (this.checkbox.checked) this.setExpiration(date.getTime());
  }

  displayErrorMessage(type) {
    this.errorMessage.classList.remove("age-gate__error--hidden");
    this.errorMessage.innerHTML = window.ageGateErrorMessages[type];
  }

  getAge(dateString) {
    const today = new Date();
    const birthDate = new Date(dateString);
    const month = today.getMonth() - birthDate.getMonth();

    let age = today.getFullYear() - birthDate.getFullYear();

    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  }
}

customElements.define("age-gate", AgeGate);